export default __webpack_public_path__ + "static/media/customer-data.f531b3de.png";